import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

const resourcesRoutes: RouteRecordRaw[] = [
  {
    path: '/resources',
    component: FullLayout,
    meta: {
      requiresAuth: true,
      title: 'PCO / Faturas - Hub',
    },
    children: [
      {
        path: 'dashboard',
        name: 'resources-dashboard',
        component: () => import('@/views/ResourcesPco/ResourcesPcoDashboard.vue'),
        meta: { title: 'PCO — Dashboard' },
      },
      {
        path: 'plan-vs-actual',
        name: 'resources-plan-vs-actual',
        component: () => import('@/views/ResourcesPco/ResourcesPcoPlanVsActual.vue'),
        meta: { title: 'PCO — Previsto × Consolidado' },
      },
      {
        path: 'budgets',
        name: 'resources-budgets',
        component: () => import('@/views/ResourcesPco/ResourcesPcoBudgets.vue'),
        meta: { title: 'PCO — Orçamentos' },
      },
      {
        path: 'budgets/:id',
        name: 'resources-budget-detail',
        component: () => import('@/views/ResourcesPco/ResourcesPcoBudgetDetail.vue'),
        props: true,
        meta: { title: 'PCO — Orçamento' },
      },
      {
        path: 'contracts',
        name: 'resources-contracts',
        component: () => import('@/views/ResourcesPco/ResourcesPcoContracts.vue'),
        meta: { title: 'PCO — Contratos' },
      },
      {
        path: 'invoices',
        name: 'resources-invoices',
        component: () => import('@/views/ResourcesPco/ResourcesPcoInvoices.vue'),
        meta: { title: 'PCO — Faturas' },
      },
      {
        path: 'allocations',
        name: 'resources-allocations',
        component: () => import('@/views/ResourcesPco/ResourcesPcoAllocations.vue'),
        meta: { title: 'PCO — Rateio por departamento' },
      },
      {
        path: 'allocation-calculator',
        name: 'resources-allocation-calculator',
        component: () => import('@/views/ResourcesPco/ResourcesPcoAllocationCalculator.vue'),
        meta: { title: 'PCO — Calculadora de rateio' },
      },
      {
        path: 'closings',
        name: 'resources-closings',
        component: () => import('@/views/ResourcesPco/ResourcesPcoClosings.vue'),
        meta: { title: 'PCO — Fechamentos' },
      },
      {
        path: 'reports',
        name: 'resources-reports',
        component: () => import('@/views/ResourcesPco/ResourcesPcoReports.vue'),
        meta: { title: 'PCO — Relatórios' },
      },
    ],
  },
];

export default resourcesRoutes;
